var _defs, _g;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgReset = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#8798ad;opacity:0;}.a,.b{stroke:#8798ad;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.b{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 40,
    height: 40,
    transform: "translate(2 2)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11 9.991)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1,4v6H7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3.51,15A9,9,0,1,0,5.64,5.64L1,10"
  }))))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReset, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/reset.c30c5535.svg";
export { ForwardRef as ReactComponent };